var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }